
import { Component, Vue } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import AppConst from '@/lib/appConst';
import Util from '@/lib/util';

@Component({
  props: {
  }
})
export default class Footer extends AbpBase {
  get tenant() {
    return Util.abp.multiTenancy.getTenantCookie();
  }

  get tenantName() {
    return this.L("ThisAppName");// AppConst.tenant.name;
  }

  get footerLinkList() {
    return JSON.parse(localStorage.getItem('footerLinkList'));
  }

  get copyright() {
    return this.L('CopyrightChar') + ' ' + new Date().getFullYear() + ' ' + this.L("PoweredBy") + ' Version 1.0.0';
  }
}
